<template>
  <div class="_pp">
    <ut-form inline>
      <ut-form-item label="策略名称" index="git">
        <ut-input v-model="name"></ut-input>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="goAdd">添加</ut-button>
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="ID" index="id" width="70" />
      <ut-table-column title="报警策略名称" index="name" min-width="135" align="center" />
      <ut-table-column title="报警方式" index="alarmTypes" inline-template min-width="120">
        <div>
          <ut-tag :type="formatType(alarmType)"
                  :style="{marginRight: '2px'}"
                  v-for="alarmType in row.alarmTypes"
                  :key="formatType(alarmType)">
            {{ formatTypeName(alarmType)}}
          </ut-tag>
        </div>
      </ut-table-column>
      <ut-table-column title="邮件-开始报警" index="mail.beginAlarmTimes" min-width="100" align="center" />
      <ut-table-column title="邮件-开始聚合" index="mail.beginAggregateTimes" min-width="100" align="center" />
      <ut-table-column title="邮件-停止报警" index="mail.maxAlarmTimes" min-width="100" align="center" />
      <!-- <ut-table-column title="邮件-聚合发送" index="mail.aggregateCount" min-width="100" align="center" /> -->

      <ut-table-column title="微信-开始报警" index="wechat.beginAlarmTimes" min-width="100" align="center" />
      <ut-table-column title="微信-开始聚合" index="wechat.beginAggregateTimes" min-width="100" align="center" />
      <ut-table-column title="微信-停止报警" index="wechat.maxAlarmTimes" min-width="100" align="center" />
      <!-- <ut-table-column title="微信-聚合发送" index="wechat.aggregateCount" min-width="100" align="center" /> -->

      <ut-table-column title="短信-开始报警" index="sms.beginAlarmTimes" min-width="100" align="center" />
      <ut-table-column title="短信-停止报警" index="sms.maxAlarmTimes" min-width="100" align="center" />

      <ut-table-column title="语音-开始报警" index="voice.beginAlarmTimes" min-width="100" align="center" />
      <ut-table-column title="语音-停止报警" index="voice.maxAlarmTimes" min-width="100" align="center" />

      <ut-table-column title="操作" inline-template fixed="right" width="140" align="center">
        <div>
          <ut-button type="info" size="small" @click="update(row)">修改</ut-button>
          <ut-popconfirm @confirm="deleteRow(row)" title="你确定要删除本行么？">
            <ut-button type="danger" size="small" :style="{marginLeft:'5px'}">删除</ut-button>
          </ut-popconfirm>
          <!-- <ut-button type="success" size="small" @click.native="copy($index,row)" :style="{marginLeft:'5px'}">复制</ut-button> -->
        </div>
      </ut-table-column>
    </ut-table>

    <ut-pagination style="margin: 10px 0;"
                   show-size-changer
                   :page-sizes='[20,50,100,150,200]'
                   :total='total'
                   :current='pageNo'
                   :page-size='pageSize'
                   @size-change='sizeChange'
                   @change='changePager' />

  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      total: 0,
      pageNo: 1,
      pageSize: 20,
      dataSource: []
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    search () {
      const url = '/policys/query.htm'
      const params = {
        name: this.name || undefined,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.$http.post(url, params)
        .then(({ data }) => {
          this.dataSource = data.dataList
          this.total = data.totalCount || 0
          this.page = data.totalPageCount > 0 ? 1 : 0
        }).catch((err = '') => {
          this.$message.error(err)
        })
    },
    sizeChange (val) {
      if (this.pageNo === 1) {
        this.$nextTick(this.search)
      }
      this.pageSize = val
    },
    changePager (val) {
      this.pageNo = val
      this.$nextTick(this.search)
    },
    goAdd () {
      this.$router.push({ path: '/policys/add' })
    },
    update (row) {
      this.$router.push({
        path: '/policys/edit',
        query: {
          id: row.id
        }
      })
    },
    deleteRow (row) {
      this.$http({
        method: 'post',
        url: 'policys/' + row.id + '/remove.htm'
      }).then(response => {
        if (response.data.code !== 0) {
          this.$message.error(response.data.message)
          return
        }
        this.search()
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    formatType (alarmType) {
      if (alarmType === 'MAIL') {
        return 'danger'
      }
      if (alarmType === 'MESSAGE') {
        return 'primary'
      }
      if (alarmType === 'WECHAT_OFFICIAL_ACCOUNTS') {
        return 'warning'
      }
      if (alarmType === 'VOICE') {
        return 'success'
      }
    },
    formatTypeName (alarmType) {
      if (alarmType === 'MAIL') {
        return '邮件'
      }
      if (alarmType === 'MESSAGE') {
        return '短信'
      }
      if (alarmType === 'WECHAT_OFFICIAL_ACCOUNTS') {
        return '微信'
      }
      if (alarmType === 'VOICE') {
        return '语音'
      }
    }

  }
}
</script>

<style lang="less" scoped>
._pp {
  padding: 16px;
}
</style>
